import request from '@/utils/request'

export const getNewsList = ({ page, size, channelCode, state, title }) => {
  return request({
    url: `/news/info/${page}/${size}`,
    params: {
      channelCode,
      state,
      title
    }
  })
}

export const postNewsEdit = (data) => {
  return request({
    method: 'post',
    url: '/news/info',
    data
  })
}

export const postNewsPublish = (id) => {
  return request({
    method: 'post',
    url: `/news/info/${id}`
  })
}

export const putNewsAdd = (data) => {
  return request({
    method: 'put',
    url: '/news/info',
    data
  })
}

export const getNewsDetail = (id) => {
  return request({
    url: `/news/info/${id}`
  })
}

export const getNewsDetailStatic = (id) => {
  return request({
    url: `/news/index/info/${id}`
  })
}
export const getNewsListStatic = ({ size, channelCode }) => {
  return request({
    url: `/news/index/info/${channelCode}/${size}`
  })
}

export const deleteNewsDel = (id) => {
  return request({
    method: 'delete',
    url: `/news/info/${id}`
  })
}

export const delNewsList = (data) => {
  return request({
    method: 'delete',
    url: '/news/info/all',
    data
  })
}
